import axios from "axios";
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const bookingsApi = {
  slots: (slug) => axios.get(`${BASE}/bookings/slots/${slug}`).then((r) => r.data),
  checkout: (payload) => axios.post(`${BASE}/bookings/checkout`, payload).then((r) => r.data),
  status: (id) => axios.get(`${BASE}/bookings/status/${id}`).then((r) => r.data),
  complete: (id, coach_email) => axios.post(`${BASE}/bookings/${id}/complete`, { coach_email }).then((r) => r.data),
  mine: () => axios.get(`${BASE}/bookings/mine`, { withCredentials: true }).then((r) => r.data),
};

export const coachOnboardApi = {
  start: (email) => axios.post(`${BASE}/coach-onboarding/start`, { email }).then((r) => r.data),
  status: (email) => axios.get(`${BASE}/coach-onboarding/status?email=${encodeURIComponent(email)}`).then((r) => r.data),
};

export const BOOKING_TESTIDS = {
  slotPicker: "booking-slot-picker",
  slotBtn: (iso) => `booking-slot-${iso}`,
  modeOnline: "booking-mode-online",
  modeInPerson: "booking-mode-in-person",
  clientEmail: "booking-client-email",
  clientName: "booking-client-name",
  submit: "booking-submit",
  error: "booking-error",
  successPage: "booking-success-page",
  successPolling: "booking-success-polling",
  successAmount: "booking-success-amount",

  onboardPage: "coach-onboard-page",
  onboardEmail: "coach-onboard-email",
  onboardStart: "coach-onboard-start",
  onboardStatus: "coach-onboard-status",
  onboardReady: "coach-onboard-ready",
};
